module.exports = __webpack_public_path__ + "img/FCT-alt.39ea5edf.svg";